
export const dealerRegistration = {
  hero: {
    badge: 'PARTNER WORDEN',
    title: 'Word Officiële Dutch Fires Dealer',
    subtitle: 'Sluit u aan bij ons exclusieve netwerk van professionele partners en profiteer van premium producten, aantrekkelijke marges en volledige ondersteuning.'
  },
  benefits: {
    title: 'Waarom Samenwerken met Dutch Fires?',
    benefit1: {
      icon: 'ri-price-tag-3-line',
      title: 'Aantrekkelijke Groothandelsprijzen',
      description: 'Profiteer van competitieve prijzen en hoge marges voor uw bedrijf'
    },
    benefit2: {
      icon: 'ri-shield-check-line',
      title: 'Exclusieve Gebiedsrechten',
      description: 'Beveilig uw territorium en minimaliseer concurrentie'
    },
    benefit3: {
      icon: 'ri-customer-service-2-line',
      title: 'Volledige Ondersteuning',
      description: 'Marketing, technische training en persoonlijke begeleiding'
    },
    benefit4: {
      icon: 'ri-truck-line',
      title: 'Flexibele Levering',
      description: 'Dropshipping, voorraad of projectlevering naar keuze'
    }
  },
  requirements: {
    title: 'Vereisten voor Dealerschap',
    subtitle: 'Om officiële Dutch Fires dealer te worden, vragen wij:',
    req1: 'Geregistreerd bedrijf (KvK of equivalent)',
    req2: 'Actief in de haard-, interieur- of bouwsector',
    req3: 'Professionele showroom of online aanwezigheid',
    req4: 'Commitment aan kwaliteit en klantenservice'
  },
  form: {
    title: 'Aanmeldformulier',
    subtitle: 'Vul onderstaand formulier in en wij nemen binnen 1-2 werkdagen contact met u op.',
    companyName: 'Bedrijfsnaam',
    companyNamePlaceholder: 'Uw bedrijfsnaam',
    contactPerson: 'Contactpersoon',
    contactPersonPlaceholder: 'Voor- en achternaam',
    email: 'E-mailadres',
    emailPlaceholder: 'uw.email@bedrijf.com',
    phone: 'Telefoonnummer',
    phonePlaceholder: '+31 20 123 4567',
    website: 'Website',
    websitePlaceholder: 'www.uwbedrijf.com',
    country: 'Land',
    countryPlaceholder: 'Selecteer uw land',
    industry: 'Branche',
    industryPlaceholder: 'Selecteer uw branche',
    message: 'Bericht',
    messagePlaceholder: 'Vertel ons over uw bedrijf en waarom u Dutch Fires dealer wilt worden...',
    submit: 'Aanmelding Versturen',
    submitting: 'Versturen...',
    success: 'Bedankt voor uw aanmelding! Wij nemen binnen 1-2 werkdagen contact met u op.',
    error: 'Er is iets misgegaan. Probeer het opnieuw of neem direct contact met ons op.',
    required: 'Dit veld is verplicht',
    invalidEmail: 'Ongeldig e-mailadres',
    industries: {
      fireplace: 'Haardenwinkel',
      interior: 'Interieurzaak',
      construction: 'Bouwbedrijf',
      ecommerce: 'E-commerce',
      other: 'Anders'
    }
  },
  process: {
    title: 'Wat Gebeurt er Na Uw Aanmelding?',
    step1: {
      title: 'Verificatie',
      description: 'Wij controleren uw bedrijfsgegevens en beoordelen uw aanvraag'
    },
    step2: {
      title: 'Persoonlijk Contact',
      description: 'Een van onze accountmanagers neemt contact met u op'
    },
    step3: {
      title: 'Onboarding',
      description: 'Toegang tot dealerportaal, training en marketingmateriaal'
    },
    step4: {
      title: 'Start Verkoop',
      description: 'Begin met verkopen en profiteer van onze ondersteuning'
    }
  },
  cta: {
    title: 'Vragen? Neem Direct Contact Op',
    email: 'info@dutchfires.de'
  }
};
